import Axios from "axios";
import {UNSET_LEAVE_LIST } from "@/store/mutation-types";

import {
  leaveProcess as leaveProcessApi,
} from "@/store/api";

const state = {

};


const getters = {

};



// Mutations
const mutations = {

};

const actions = {
    leaveProcess({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(leaveProcessApi, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },
};


export default {
  state,
  getters,
  actions,
  mutations,
};